import {
  CLEAR_UI_FORM_ELEMENTS,
} from './constant'

export const clearUiFormElements = () => {
  return {
    type: CLEAR_UI_FORM_ELEMENTS,
  }
}
